import { render } from "./IdentifyDblTop.vue?vue&type=template&id=3664795c&scoped=true"
import script from "./IdentifyDblTop.vue?vue&type=script&lang=js"
export * from "./IdentifyDblTop.vue?vue&type=script&lang=js"

import "./IdentifyDblTop.vue?vue&type=style&index=0&id=3664795c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3664795c"]])

export default __exports__